import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';
import Recorder from './Recorder';
import { RootState } from './store';

const App: React.FC = () => {
  const { t } = useTranslation();
  const { recorder } = useSelector((state: RootState) => state);
  const { status, upload } = recorder;

  switch (status) {
    case 'initializing':
      return <div className="p-4 text-center">{t('recorder.app.loading')}</div>;
    case 'failed':
      return (
        <div className="p-4 max-w-md mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
            <div className="flex items-start">
              <WifiOff className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-red-800 mb-1">
                  {t('recorder.app.connectionError.title')}
                </h3>
                <p className="text-sm text-red-700">
                  {upload.error ||
                    t('recorder.app.connectionError.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    default:
      return <Recorder />;
  }
};

export default App;
